module.exports = __webpack_public_path__ + "static/img/03.f36cf455.gif";